// extracted by mini-css-extract-plugin
export var loadingSpinner = "_63-1";
export var standaloneTable = "_63-0";